import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-content-card',
  templateUrl: './content-card.component.html',
  standalone: false,
})
export class ContentCardComponent {
  @Input() header: { hide?: boolean; title?: string; subtitle?: string } = {};
}
